import path from "path";
import { readFile } from "fs";
import { promisify } from "util";
import { Readable } from "stream";

import pLimit, { Limit } from "p-limit";

import { Observe } from "../../../../Commons/TasksCore/Observe";
import { execCommandAsync } from "../../../../Commons/ExecUtils";
import { getLogger } from "../../../../Commons/Logging/StaticLogger";

const readFileAsync = promisify(readFile);

export class CandyWidgetDevServer {
    // @ts-ignore
    private readonly port: number;
    private readonly engineDirectory: string;
    private readonly startParallelLimit: Limit;
    private started = false;
    // @ts-ignore
    private readonly buildDebugOnly: boolean;
    private disposer?: () => Promise<void>;

    public constructor(engineDirectory: string, buildDebugOnly: boolean) {
        this.engineDirectory = engineDirectory;
        this.startParallelLimit = pLimit(1);
        this.buildDebugOnly = buildDebugOnly;
    }
    public async start(): Promise<void> {
        return this.startParallelLimit(async () => {
            if (this.started) {
                return;
            }
            const candyWidgetRoot = path.join(this.engineDirectory, "Widgets", "CandyWidget");
            const filesObserver = Observe.files(candyWidgetRoot, "**/*").do(async () => {
                const logger = getLogger().withPrefix("WIDGET");
                await execCommandAsync(logger, "npm run build:loader", {
                    cwd: candyWidgetRoot,
                });
                await execCommandAsync(logger, "npm run build:widget", {
                    cwd: candyWidgetRoot,
                });
                await execCommandAsync(logger, "npm run build:jsLoader", {
                    cwd: candyWidgetRoot,
                });
            });

            this.disposer = await filesObserver.observe();

            this.started = true;
        });
    }

    public async stop(): Promise<void> {
        await (this.disposer ?? Promise.resolve)();
    }

    public async getFileStream(filePathUrl: string): Promise<NodeJS.ReadableStream> {
        const parts = filePathUrl.split("/");
        const finalPath = path.join(this.engineDirectory, "Widgets", "CandyWidget", ".artifacts", ...parts);
        const fileData = await readFileAsync(finalPath);
        return new Readable({
            read: function () {
                this.push(fileData);
                this.push(null);
            },
        });
    }
}
